"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaConfiguration = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var nft_hooks_1 = require("@zoralabs/nft-hooks");

var merge_anything_1 = require("merge-anything");

var content_components_1 = require("../content-components");

var MediaContext_1 = require("./MediaContext");

var MediaConfiguration = function MediaConfiguration(_ref) {
  var networkId = _ref.networkId,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children,
      _ref$strings = _ref.strings,
      strings = _ref$strings === void 0 ? {} : _ref$strings,
      renderers = _ref.renderers;
  var superContext = react_1.useContext(MediaContext_1.MediaContext);
  var newNetworkId = networkId || superContext.networkId;

  if (!renderers) {
    renderers = content_components_1.MediaRendererDefaults;
  }

  var newContext = {
    // TODO(iain): Fix typing
    style: merge_anything_1.merge(superContext.style, style),
    strings: merge_anything_1.merge(superContext.strings, strings),
    renderers: renderers,
    networkId: newNetworkId
  };
  return jsx_runtime_1.jsx(MediaContext_1.MediaContext.Provider, Object.assign({
    value: newContext
  }, {
    children: jsx_runtime_1.jsx(nft_hooks_1.NFTFetchConfiguration, Object.assign({
      networkId: newNetworkId
    }, {
      children: children
    }), void 0)
  }), void 0);
};

exports.MediaConfiguration = MediaConfiguration;